import { ROUTES } from "@/routes";
import type { ClientAction } from "@/helpers/clientPermissions";
import { matchPath } from "react-router-dom";

const routePermissions = [
  {
    path: ROUTES.ADMIN_BUILDING_HEATING,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_EXTERNAL_INTEGRATIONS,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_CLIENTS,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_CLIENT_DETAIL,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_DATA_IMPORT,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_BUILDING_DETAIL,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_BUILDING_CARD,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_ADMINS,
    permission: "admins",
  },
  {
    path: ROUTES.ADMIN_ADMIN_DETAIL,
    permission: "admins",
  },
  {
    path: ROUTES.ADMIN_FREQUENTLY_ASKED_QUESTIONS,
    permission: "faqs",
  },
  {
    path: ROUTES.ADMIN_FREQUENTLY_ASKED_QUESTIONS_FORM,
    permission: "faqs",
  },
  {
    path: ROUTES.ADMIN_DELETED_ITEMS,
    permission: "deleted-items",
  },
] as const;

export function findRoutePermission(pathname: string) {
  return routePermissions.find((route) => matchPath({ path: route.path, end: true }, pathname))?.permission;
}

const clientRouteActions: ReadonlyArray<{ path: string; action: ClientAction }> = [
  { path: ROUTES.CLIENT_DATA_IMPORT, action: 'consumption_write' },
  { path: ROUTES.CLIENT_UPLOAD_INVOICE, action: 'invoice_write' },
  { path: ROUTES.CLIENT_UPLOAD_INVOICE_COL_POINT, action: 'invoice_write' },
  { path: ROUTES.CLIENT_EDIT_INVOICE, action: 'invoice_write' },
  { path: ROUTES.CLIENT_EDIT_INVOICE_COL_POINT, action: 'invoice_write' },
  { path: ROUTES.CLIENT_PRODUCTION_INVOICE, action: 'invoice_write' },
  { path: ROUTES.CLIENT_UPLOAD_CONSUMPTION, action: 'consumption_write' },
  { path: ROUTES.CLIENT_UPLOAD_CONSUMPTION_COL_POINT, action: 'consumption_write' },
  { path: ROUTES.CLIENT_EDIT_CONSUMPTION, action: 'consumption_write' },
  { path: ROUTES.CLIENT_EDIT_CONSUMPTION_COL_POINT, action: 'consumption_write' },
  { path: ROUTES.CLIENT_ADD_BUILDING, action: 'full_write' },
  { path: ROUTES.CLIENT_EDIT_BUILDING, action: 'full_write' },
  { path: ROUTES.CLIENT_ADD_COLLECTION_POINT, action: 'full_write' },
  { path: ROUTES.CLIENT_EDIT_COLLECTION_POINT, action: 'full_write' },
];

export function findClientRouteAction(pathname: string) {
  return clientRouteActions.find((route) => matchPath({ path: route.path, end: true }, pathname))?.action;
}
